import { HomeSlideRepository } from '../../domain/repositories/home-slide.repository';
import { HomeSlideEntity } from '../../domain/entities/home-slide.entity';

export class GetHomeSlidesUseCase {
  constructor(private readonly homeSlideRepository: HomeSlideRepository) {}

  public async execute(activeOnly: boolean = false): Promise<HomeSlideEntity[]> {
    return this.homeSlideRepository.getSlides(activeOnly);
  }
}
